<script lang="ts">
	import { format } from 'svelte-i18n';
	// Stores
	import { devicesFiltersInitialState } from 'src/stores/ui/filters';
	import type { FilterOption } from 'src/stores/ui/filters';
	// Design system components
	import { Token } from '@Shelly/shelly-design-system';
	import { deepCopy } from 'src/helpers/utilities';

	export let appliedFilters;
	export let toggleFilterOptions;

	let filterOptions = [
		{
			id: 'shared',
			title: $format('shared_devices', { default: 'shared devices' }),
			value: -20,
			translationDefault: 'shared devices',
			selected: false,
		},
		{
			id: 'all_shared',
			title: $format('all_shared_devices', { default: 'all shared devices' }),
			value: -40,
			translationDefault: 'all shared devices',
			selected: false,
		},
		{
			id: 'all_owned',
			title: $format('all_owned_devices', { default: 'all owned devices' }),
			value: 0, // not sure which number to put here
			translationDefault: 'all owned devices',
			selected: false,
		},
		{
			id: 'shared_by_me',
			title: $format('shared_devices_by_me', {
				default: 'shared devices by me',
			}),
			value: -60, // not sure which number to put here
			translationDefault: 'shared devices by me',
			selected: false,
		},
	].map((option) => {
		const storeOption = appliedFilters.shared_devices.find((filter) => filter.id === option.id);
		option.selected = storeOption.selected;
		return option;
	});

	const handleSelectFilter = (option) => {
		appliedFilters.shared_devices = appliedFilters.shared_devices.map((filter) => {
			if (filter.id === option.id) {
				filter.selected = !filter.selected;
				return filter;
			}
			return filter;
		});

		filterOptions = toggleFilterOptions(filterOptions, option);
	};

	const resetData = () => {
		appliedFilters.shared_devices = deepCopy(devicesFiltersInitialState.shared_devices);

		filterOptions = filterOptions.map((filter) => {
			return {
				...filter,
				selected: false,
			};
		});
	};
</script>

<svelte:window on:reset={resetData} />

<div class="d-flex flex-wrap" style="gap: 8px;">
	{#each filterOptions as option}
		<Token
			id="token-ditzu53"
			size="m"
			title={option.title}
			on:click={() => handleSelectFilter(option)}
			selected={option.selected}
			disabled={option.id === 'shared' &&
				appliedFilters.rooms.find((filter) => filter.value !== 'all')}
		/>
	{/each}
</div>
